import { Spine } from '../spine';
import { spineKeysConfig } from '../../../games/powerOfGods/powerOfGodsCore/constants/globalConstants';
import { PixiContainer } from '../pixiContainer';
import { iconStates } from '../../../games/powerOfGods/powerOfGodsCore/constants/reelConstants';

export class SlotIcon extends PixiContainer {
  constructor(options) {
    super(options);
    const styles = { origin: 0.5, roundPixels: false };
    this.animationType = 'slotIcon';
    this.winParent = options.winParent;
    this.index = options.index;
    this.reelIndex = options.reelIndex;
    this.xPosition = options.xPosition;
    this.rowIndex = options.rowIndex;
    this.parent = options.parent;
    this.spinParent = this.parent;
    this.key = options.key;
    this.icon = this.addChild(
      new Spine({
        key: spineKeysConfig[options.key],
        styles: styles,
        spineKeysConfig: options.key,
      })
    );
    this.iconNumber = options.key;
    this.loop = false;
    this.currentState = null;
    this.changeState(iconStates.idle);
    this.roundPixels = false;
    this.children.forEach((c) => {
      c.roundPixels = false;
    });
    this.xPosInReel = this.x;
    this.yPosInReel = this.y;
    this.yPosInWin = this.y;
    this.xPosInWin = this.x;
  }

  setWinContainerPositions(positions) {
    this.xPosInWin = positions.xInWin;
    this.yPosInWin = positions.yInWin;
  }

  changeIcon(newNumber, state = iconStates.idle, timeScale = 1) {
    if (newNumber === this.iconNumber) return;
    this.iconNumber = newNumber;
    this.key = newNumber;
    this.index = newNumber;
    this.icon.show();
    this.icon.changeTexture(this.iconNumber?.toString());
    this.changeState(state, timeScale);
  }

  changeState(state, timeScale = 1) {
    this.currentState = state;
    this.icon.stop();
    this.changeToActualParent();
    if (this.icon) {
      const promise = new Promise((res) => {
        this.icon.addListener('complete', res);
      });
      this.icon.play(state, state === iconStates.idle, timeScale);
      this.icon.clearListeners();
      return promise;
    }
    return Promise.resolve(false);
  }

  addOnCompleteHandler(handler, context = null, once = false) {
    if (this.icon) {
      this.icon.addListener('complete', handler, context);
      const spine = this.icon;
      return () => {
        spine.removeListener('complete', handler, context);
      };
    }
    const hh = this.icon.loop ? 'onLoop' : 'onComplete';
    const a = once
      ? () => {
          handler.call(context);
          this.icon[hh] = null;
        }
      : () => {
          handler.call(context);
        };
    this.icon[hh] = a;
    return () => {
      this.icon[hh] = null;
    };
  }

  checkParent() {
    return this.parent === this.spinParent ? 'Reel' : 'WIN Container';
  }

  changeToActualParent() {
    const parent = this.currentState === iconStates.win ? this.winParent : this.spinParent;
    if (parent !== this.parent) {
      parent.addChild(this);
      if (parent === this.spinParent) {
        this.x = this.xPosInReel;
        this.y = this.yPosInReel;
      }
      if (parent === this.winParent) {
        this.x = 0;
        this.y = 0;
      }
    }
  }
}

export function getIconValueFromIconNumber(iconNumber) {
  return Number(iconNumber.toString().split('-')[1] || 0);
}
